import React from 'react';
import classnames from 'classnames';
import DeviationsMosaic from '../DeviationsMosaic';
import StandardThumb from '../DeviationViews/Thumb/Standard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './MeasuredDeviationsMosaic.scss';
const defaultPadding = parseInt(s['padding']);
const MeasuredDeviationsMosaic = ({ deviations, contentClassName, className, cookieType = MeasuredCookieType.BROWSE, height = 375, padding = defaultPadding, deviationView = StandardThumb })=>{
    const { ref, dimensions } = useMeasureElementCookie(cookieType, {
        cookieDim: 'width'
    });
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, /*#__PURE__*/ React.createElement(DeviationsMosaic, {
        width: dimensions.width,
        height: height,
        deviations: deviations,
        contentClassName: classnames(contentClassName, s['default-padding']),
        className: className,
        padding: padding,
        deviationView: deviationView
    }));
};
MeasuredDeviationsMosaic.displayName = 'MeasuredDeviationsMosaic';
export default MeasuredDeviationsMosaic;
